import { isEmpty, isUndefined, forEach } from 'lodash';

export const entitlementServices = (entitStr: string, deadStr: string) => {
    const service: any = {
        DEADEN_COMPONENTS: {},
        ENTITLED_COMPONENTS: {},
        isEntitled(componentName: string) {
            return (!isEmpty(componentName)
                && !isUndefined(service.ENTITLED_COMPONENTS[componentName]));
        },
        isDeaden(componentName: string) {
            return (!isEmpty(componentName)
                && !isUndefined(service.DEADEN_COMPONENTS[componentName]));
        },
        showDiv(subComp1: string, subComp2: string) {
            return (this.isEntitled(subComp1) || this.isDeaden(subComp1) || this.isEntitled(subComp2) || this.isDeaden(subComp2));
        },
        showSeparator(subComp1: string, subComp2: string) {
            return ((this.isEntitled(subComp1) || this.isDeaden(subComp1)) && (this.isEntitled(subComp2) || this.isDeaden(subComp2)));
        }
    };

    function populateComponentEntitlements() {
        // Populate deaden components
        const deadenComponents = deadStr?.split(',');
        forEach(deadenComponents, (value) => {
            service.DEADEN_COMPONENTS[value] = true;
        });

        // Populate entitlement components
        const entitledComponents = entitStr?.split(',');
        forEach(entitledComponents, (value) => {
            service.ENTITLED_COMPONENTS[value] = true;
        });
    }

    populateComponentEntitlements();

    return service;
};
